import Validation from '../../common/assets/js/validation';

export default new class AccountProfile {
    constructor() {
        this.saveUserProfileBtn = '.js-saveUserProfile';
        this.form = $('.account-form_profile');
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document)
            .on('click', this.saveUserProfileBtn, (e) => {
                let $form = $(this.form);

                if (!Validation.isFormValid($form)) {
                    e.preventDefault();
                }
            }).on('blur', 'input[required]', (e) => {
                Validation.validateInput(e.target);
            });
    }
};



// WEBPACK FOOTER //
// ./src/pages/account-profile/account-profile.js